import i18n from '@tecma/i18n';

const currencyFormatter = (currency: string, value: number, extraValue = '') => {
  try {
    return new Intl.NumberFormat(i18n.language || 'it-IT', {
      style: 'currency',
      currency: currency || 'EUR',
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    })
      .format(value)
      .concat(extraValue);
  } catch (error) {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    })
      .format(value)
      .concat(extraValue);
  }
};

export default currencyFormatter;
